(() => {
  const clamp = (n, min = 0, max = 1) => Math.min(max, Math.max(min, n));
  const smooth = (t) => t * t * (3 - 2 * t);

  document.documentElement.classList.remove('no-js');

  const header = document.querySelector('[data-header]');
  const menuComponent = document.querySelector('[data-header-component]');
  const menuToggle = menuComponent?.querySelector('[data-menu-toggle]');
  const drawer = menuComponent?.querySelector('[data-mobile-drawer]');
  const menuBackdrop = menuComponent?.querySelector('[data-menu-backdrop]');
  const menuClose = menuComponent?.querySelector('[data-menu-close]');

  if (menuToggle && drawer) {
    let lockedScrollY = 0;

    const lockPage = () => {
      lockedScrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.classList.add('sovr-menu-open');
    };

    const unlockPage = () => {
      document.body.classList.remove('sovr-menu-open');
      document.body.style.top = '';
      window.scrollTo(0, lockedScrollY);
    };

    const setMenu = (open) => {
      const isOpen = Boolean(open);
      drawer.classList.toggle('is-open', isOpen);
      menuBackdrop?.classList.toggle('is-open', isOpen);
      menuToggle.classList.toggle('is-open', isOpen);
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      menuToggle.setAttribute('aria-label', isOpen ? 'Menü schließen' : 'Menü öffnen');
      drawer.setAttribute('aria-hidden', String(!isOpen));
      if (menuBackdrop) menuBackdrop.tabIndex = isOpen ? 0 : -1;

      if (isOpen) {
        lockPage();
        requestAnimationFrame(() => menuClose?.focus({ preventScroll: true }));
      } else {
        unlockPage();
        menuToggle.focus({ preventScroll: true });
      }
    };

    menuToggle.addEventListener('click', (event) => {
      event.preventDefault();
      setMenu(!drawer.classList.contains('is-open'));
    });
    menuBackdrop?.addEventListener('click', () => setMenu(false));
    menuClose?.addEventListener('click', () => setMenu(false));
    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
    addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) setMenu(false);
    });
    addEventListener('resize', () => {
      if (innerWidth > 990 && drawer.classList.contains('is-open')) setMenu(false);
    });
  }

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach((el) => revealObserver.observe(el));

  const cursor = document.querySelector('.sovr-cursor');
  if (cursor && matchMedia('(pointer:fine)').matches) {
    let x = -100, y = -100, cx = -100, cy = -100;
    addEventListener('pointermove', (e) => { x = e.clientX; y = e.clientY; });
    const tick = () => {
      cx += (x - cx) * .22; cy += (y - cy) * .22;
      cursor.style.transform = `translate(${cx}px,${cy}px) translate(-50%,-50%)`;
      requestAnimationFrame(tick);
    };
    tick();
    document.querySelectorAll('a,button,input,select,[data-product-card]').forEach((el) => {
      el.addEventListener('pointerenter', () => cursor.classList.add('is-hover'));
      el.addEventListener('pointerleave', () => cursor.classList.remove('is-hover'));
    });
  }

  document.querySelectorAll('.magnetic').forEach((el) => {
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      el.style.transform = `translate(${(e.clientX-r.left-r.width/2)*.08}px,${(e.clientY-r.top-r.height/2)*.12}px)`;
    });
    el.addEventListener('pointerleave', () => el.style.transform = '');
  });

  const tilt = document.querySelector('[data-tilt]');
  if (tilt && matchMedia('(pointer:fine)').matches) {
    tilt.addEventListener('pointermove', (e) => {
      const r = tilt.getBoundingClientRect();
      const rx = ((e.clientY-r.top)/r.height-.5)*-8;
      const ry = ((e.clientX-r.left)/r.width-.5)*10;
      tilt.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg)`;
    });
    tilt.addEventListener('pointerleave', () => tilt.style.transform = '');
  }

  document.querySelectorAll('[data-drag-track]').forEach((track) => {
    const finePointer = matchMedia('(pointer:fine)').matches;
    let pointerDown = false;
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let suppressNextClick = false;
    const dragThreshold = 8;

    track.addEventListener('pointerdown', (event) => {
      // Echte Links und Buttons niemals abfangen.
      if (event.target.closest('a, button, input, select, textarea')) return;

      // Auf Touch-Geräten das natürliche Wischen des Browsers verwenden.
      if (!finePointer || event.pointerType === 'touch') return;
      if (typeof event.button === 'number' && event.button !== 0) return;

      pointerDown = true;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      suppressNextClick = false;
    });

    track.addEventListener('pointermove', (event) => {
      if (!pointerDown) return;

      const distance = event.clientX - startX;

      if (Math.abs(distance) > dragThreshold) {
        suppressNextClick = true;
        track.classList.add('is-dragging');

        if (pointerId !== null && track.setPointerCapture && !track.hasPointerCapture(pointerId)) {
          track.setPointerCapture(pointerId);
        }

        track.scrollLeft = startScrollLeft - distance * 1.15;
        event.preventDefault();
      }
    });

    const finishDrag = () => {
      pointerDown = false;
      pointerId = null;
      track.classList.remove('is-dragging');

      // Das direkt nach pointerup ausgelöste click-Event wird noch unterdrückt.
      setTimeout(() => {
        suppressNextClick = false;
      }, 0);
    };

    track.addEventListener('pointerup', finishDrag);
    track.addEventListener('pointercancel', finishDrag);
    track.addEventListener('lostpointercapture', finishDrag);

    track.addEventListener('click', (event) => {
      if (suppressNextClick) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      // Bild, Titel, Preis und CTA sind echte Links und funktionieren selbstständig.
      if (event.target.closest('a, button, input, select, textarea')) return;

      // Auch ein Klick auf die freie Fläche einer Karte öffnet das Produkt.
      const card = event.target.closest('[data-product-card]');
      const productUrl = card?.dataset.productUrl;

      if (productUrl) {
        window.location.assign(productUrl);
      }
    });
  });

  const dress = document.querySelector('[data-dress-scroll]');
  if (dress) {
    const layers = [...dress.querySelectorAll('[data-dress-layer]')];
    const bar = dress.querySelector('[data-dress-progress]');
    const steps = [...dress.querySelectorAll('[data-dress-steps] button')];
    const look = dress.querySelector('[data-look-number]');
    const label = dress.querySelector('[data-dress-label]');
    let ticking = false;
    const renderDress = () => {
      const rect = dress.getBoundingClientRect();
      const range = Math.max(1, rect.height - innerHeight);
      const p = clamp(-rect.top / range);
      if (bar) bar.style.transform = `scaleX(${p})`;
      layers.forEach((layer) => {
        const start = Number(layer.dataset.start || 0);
        const end = Number(layer.dataset.end || 1);
        const out = layer.dataset.out ? Number(layer.dataset.out) : 1.15;
        let t = smooth(clamp((p-start)/(end-start)));
        let opacity = t;
        if (p > end && out <= 1) opacity = 1-smooth(clamp((p-end)/(out-end)));
        const from = layer.dataset.from;
        let x=0,y=0,rot=0,scale=.82 + t*.18;
        if (from==='left') { x=(1-t)*-180; rot=(1-t)*-10; }
        if (from==='right') { x=(1-t)*180; rot=(1-t)*10; }
        if (from==='top') { y=(1-t)*-160; rot=(1-t)*4; }
        if (from==='bottom') { y=(1-t)*180; }
        layer.style.opacity = opacity;
        layer.style.transform = `translate3d(${x}px,${y}px,0) rotate(${rot}deg) scale(${scale})`;
      });
      let active = 0;
      if (p>.13) active=1; if(p>.31) active=2; if(p>.52) active=3; if(p>.75) active=4;
      steps.forEach((s,i)=>s.classList.toggle('is-active',i===active));
      if (look) look.textContent = String(active).padStart(2,'0');
      if (label) label.textContent = ['SCROLL TO DRESS','KIKU DENIM','SILENCE TEE','FORELSKET','DENIM ZIP'][active];
      ticking = false;
    };
    const requestDress = () => { if(!ticking){ ticking=true; requestAnimationFrame(renderDress); } };
    addEventListener('scroll',requestDress,{passive:true}); addEventListener('resize',requestDress); renderDress();
    steps.forEach((s,i)=>s.addEventListener('click',()=>{
      const rect=dress.getBoundingClientRect(); const top=scrollY+rect.top; const targets=[0,.17,.36,.57,.81];
      scrollTo({top:top+targets[i]*(dress.offsetHeight-innerHeight),behavior:'smooth'});
    }));
  }


  document.querySelectorAll('[data-sovr-orbit]').forEach((hero) => {
    const stage = hero.querySelector('[data-sovr-orbit-stage]');
    const items = [...hero.querySelectorAll('[data-sovr-orbit-item]')];
    if (!stage || !items.length) return;

    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const direction = Number(hero.dataset.orbitDirection || 1);
    const orbitDegrees = Number(hero.dataset.orbitDegrees || 100) * direction;
    const productSpin = Number(hero.dataset.productSpin || 15);
    let sectionTop = 0;
    let scrollRange = 1;
    let stageWidth = 1;
    let stageHeight = 1;
    let lastViewportWidth = 0;
    let ticking = false;

    const measure = (force = false) => {
      const viewportWidth = document.documentElement.clientWidth;
      if (!force && Math.abs(viewportWidth - lastViewportWidth) < 20) return;
      lastViewportWidth = viewportWidth;
      const rect = hero.getBoundingClientRect();
      sectionTop = scrollY + rect.top;
      scrollRange = Math.max(1, hero.offsetHeight - document.documentElement.clientHeight);
      stageWidth = Math.max(1, stage.clientWidth);
      stageHeight = Math.max(1, stage.clientHeight);
    };

    const renderOrbit = () => {
      const progress = reducedMotion ? 0 : clamp((scrollY - sectionTop) / scrollRange);
      const mobile = matchMedia('(max-width: 990px)').matches;
      const styles = getComputedStyle(hero);
      const widthValue = styles.getPropertyValue(mobile ? '--orbit-width-mobile' : '--orbit-width-desktop');
      const heightValue = styles.getPropertyValue(mobile ? '--orbit-height-mobile' : '--orbit-height-desktop');
      const widthPercent = (parseFloat(widthValue) || 90) / 100;
      const heightPercent = (parseFloat(heightValue) || 68) / 100;
      const radiusX = stageWidth * widthPercent * .5;
      const radiusY = stageHeight * heightPercent * .5;
      const count = items.length;

      items.forEach((item, index) => {
        const angleDegrees = (360 / count) * index - 90 + progress * orbitDegrees;
        const angle = angleDegrees * Math.PI / 180;
        const x = Math.cos(angle) * radiusX;
        const y = Math.sin(angle) * radiusY;
        const depth = (Math.sin(angle) + 1) * .5;
        const scale = .82 + depth * .18;
        const spinDirection = index % 2 === 0 ? 1 : -1;
        const rotation = Math.sin(angle) * 3 + progress * productSpin * spinDirection;
        item.style.zIndex = String(5 + Math.round(depth * 15));
        item.style.opacity = String(.76 + depth * .24);
        item.style.transform = `translate3d(calc(-50% + ${x}px),calc(-50% + ${y}px),0) rotate(${rotation}deg) scale(${scale})`;
      });
      ticking = false;
    };

    const requestOrbit = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(renderOrbit);
      }
    };

    measure(true);
    renderOrbit();
    addEventListener('scroll', requestOrbit, { passive: true });
    addEventListener('resize', () => { measure(false); requestOrbit(); });
    addEventListener('orientationchange', () => {
      setTimeout(() => { measure(true); requestOrbit(); }, 200);
    });
  });

  const parallaxEls = [...document.querySelectorAll('[data-parallax]')];
  if (parallaxEls.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let scheduled = false;
    const renderParallax = () => {
      parallaxEls.forEach((el) => {
        const r = el.getBoundingClientRect();
        const speed = Number(el.dataset.parallax || 0);
        const offset = (r.top + r.height/2 - innerHeight/2) * speed;
        el.style.marginTop = `${offset}px`;
      });
      scheduled=false;
    };
    addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(renderParallax)}},{passive:true}); renderParallax();
  }

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form) });
        if (!response.ok) throw new Error('Could not add item');
        const toast = document.querySelector('[data-cart-toast]');
        if (toast) { toast.classList.add('is-visible'); setTimeout(()=>toast.classList.remove('is-visible'),2200); }
        const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(r=>r.json());
        document.querySelectorAll('.cart-link span').forEach(el=>el.textContent=cart.item_count);
      } catch (error) { form.submit(); }
      finally { if (button) button.disabled = false; }
    });
  });

  document.querySelectorAll('[data-header-model-logo]').forEach((model) => {
    const markLoaded = () => {
      model.classList.add('is-loaded');
      model.closest('.wordmark-3d')?.classList.add('is-model-ready');
    };
    model.addEventListener('load', markLoaded, { once: true });
    if (model.loaded) markLoaded();
  });
})();